<template>
  <div class='have-zoom'>
    <h1>汇说活动管理列表</h1>
    <el-table :data='tableShow'>
      <el-table-column prop='id' label='活动ID'/>
      <el-table-column prop='title' label='活动标题' />
      <el-table-column prop='city' label='举办城市' />
      <el-table-column prop='hold_date' label='时间' />
      <el-table-column prop='earlyBird' label='早鸟票' />
      <el-table-column prop='saverTpuicket' label='优惠票' />
      <el-table-column prop='normalFare' label='普通票' />
      <el-table-column prop='limit' label='(不)限制人数' />
      <el-table-column prop='companyNum' label='已报名公司' />
      <el-table-column fixed='right' label='开放状态'>
        <template slot-scope='scope'>
          <div :class="['switch-b',scope.row.status==='open'?'active-switch-b':'']" @click='changeStatus(scope.row)'>
            <div :class="['switch-b-div',scope.row.status==='open'?'active-div':'']"></div>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed='right' label='目前售票状态'>
        <template slot-scope='scope'>
          <div class="switch-box">
            <el-select v-model="scope.row.ticketStatus" @change='changeTicket(scope.row)' :key="scope.row.id">
              <el-option
                v-for="item in authority"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed='right' label='相关操作' min-width='200'>
        <template slot-scope='scope'>
          <!-- <el-button @click="editrow(scope.row.id)" type="text" size="small">编辑会议</el-button> -->
          <el-button @click='inforow(scope.row.id)' type="text" size="small">通知参会(个人)</el-button>
          <el-button @click='allUser(scope.row.id)' type="text" size="small">已申请报名用户(个人)</el-button>
          <el-button @click='allCompany(scope.row.id)' type="text" size="small">已申请报名用户(公司)</el-button>          
        </template>
      </el-table-column>
    </el-table>
    <div class="normal-pagination">
      <el-pagination layout="prev, pager, next" :page-size="8" :total="total" style="float:right" @current-change='changePage'>
      </el-pagination>
    </div>
  </div>

</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      tableData: [],
      tableShow: [],
      nowDate: new Date(),
      authority: [
        { label: "早鸟票", value: "0" },
        { label: "优惠票", value: "1" },
        { label: "普通票", value: "2" }
      ]
    };
  },
  methods: {
    changeTime(t) {
      let time = new Date(t);
      let mi = time.getMinutes();
      if (mi === 0) {
        mi = `00`;
      }
      return `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}`;
    },
    changeStatus(item) {
      let hold = item.status === "open" ? "close" : "open";
      let form = { ...item };
      form.status = hold;
      this.$http.estateforum_update_summit({ ...form }).then(res => {
        if (res.data.statusCode === 200) {
          item.status = hold;
        } else {
          this.$message.error("修改状态未成功");
        }
      });
    },
    changeTicket(item) {
      this.$http.estateforum_update_summit({ ...item }).then(res => {
        if (res.data.statusCode === 200) {
        } else {
          this.$message.error("修改状态未成功");
        }
      });
    },
    changePage(id) {
      const start = (id - 1) * 8;
      const end = start + 8;
      this.tableShow = this.tableData.slice(start, end);
    },
    editrow(id) {
      this.$router.push(`/freetalks/post/${id}`);
    },
    inforow(id) {
      this.$router.push(`/sms/freetalks/${id}`);
    },
    allUser(id) {
      this.$router.push(`/estateforum_users_status_list/${id}`);
    },
    allCompany(acid) {
      this.$router.push(`/estateforum_company_status_list/${acid}`);
    },
    initData() {
      this.$http.estateforum_summit_list().then(res => {
        if (res.data.statusCode === 200) {
          this.tableData = res.data.result.reverse();
          let acid = [];
          this.tableData.forEach(item => {
            item.hold_date = this.changeTime(item.date);
            acid.push(item.id);
          });
          this.$http.estateforum_company_info_list({ acid }).then(res => {
            if (res.data.statusCode === 200) {
              console.log(res.data);
              this.tableData.forEach(tab => {
                tab.companyNum = 0;
                tab.companyList = [];
                res.data.result.forEach(item => {
                  if (item.acid == tab.id) {
                    tab.companyNum++;
                    tab.companyList.push(item);
                  }
                });
              });
              this.getTicketInfo();

              this.changePage(1);
            } else {
              this.$message.error("数据请求未成功");
            }
          });
        } else {
          this.$message.error("数据请求未成功");
        }
      });
    },
    getTicketInfo() {
      axios.get("acapi/ac/estateforum/get_all_ticket_info").then(res => {
        this.tableShow[0].earlyBird = res.data.result.earlyBird;
        this.tableShow[0].saverTpuicket = res.data.result.saverTpuicket;
        this.tableShow[0].normalFare = res.data.result.normalFare;
      });
    }
  },
  computed: {
    total() {
      return this.tableData.length;
    }
  },
  mounted() {
    this.initData();
  }
};
</script>

<style>
.el-table__fixed,
.el-table__fixed-right {
  overflow: hidden;
}
.switch-b {
  margin-left: 20px;
  width: 40px;
  height: 22px;
  border-radius: 15px;
  background-color: rgb(218, 0, 0);
  transition: background-color 400ms;
  cursor: pointer;
  position: relative;
}
.active-switch-b {
  background-color: rgb(0, 202, 216);
}
.switch-b-div {
  position: absolute;
  top: 50%;
  margin: 0 2px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #fff;
  transition: transform 400ms;
  transform: translateX(0%) translateY(-50%);
}
.active-div {
  transform: translateX(100%) translateY(-50%);
}
.over-time {
  color: red;
  margin-left: 5px;
}
.close-time {
  margin-left: 5px;
  color: lightseagreen;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/estateforum/estateforum.vue